import { render, staticRenderFns } from "./GeneralSettingsTaxesType.vue?vue&type=template&id=77acbe99&"
import script from "./GeneralSettingsTaxesType.vue?vue&type=script&lang=ts&"
export * from "./GeneralSettingsTaxesType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports